import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { guaranteeCards, warrantyFaqItems } from "@/config/warranty-faq";
import { useI18n } from "@/i18n";
import { getMarketingCopy } from "@/i18n/marketing-copy";

export function AboutGuarantee() {
  const { locale } = useI18n();
  const copy = getMarketingCopy(locale)?.about.guarantee;
  const cards = copy?.cards ?? guaranteeCards;
  const faqs = copy?.faqs ?? warrantyFaqItems;
  return (
    <section id="guarantee" className="section-y">
      <div className="container-page">
        <p className="eyebrow">{copy?.eyebrow ?? "Our guarantee"}</p>
        <h2 className="display-2 mt-3 max-w-3xl text-balance">
          {copy?.title ?? "Written workmanship coverage, plus manufacturer material warranties"}
        </h2>
        <p className="mt-4 max-w-3xl text-[1.02rem] leading-relaxed text-muted-foreground">
          {copy?.body ??
            "Warranty terms that matter are the ones in your project documents. The summaries below describe the two coverage layers Revolin Roofing puts in writing for qualifying work."}
        </p>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {cards.map((card) => (
            <article key={card.title} className="rounded-xl border border-border bg-card p-8">
              <h3 className="text-xl font-semibold">{card.title}</h3>
              <p className="mt-4 text-sm leading-7 text-muted-foreground">{card.body}</p>
            </article>
          ))}
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.25fr)]">
          <div>
            <p className="eyebrow">{copy?.faqEyebrow ?? "Warranty FAQ"}</p>
            <h3 className="display-3 mt-3">
              {copy?.faqTitle ?? "Common questions about coverage"}
            </h3>
          </div>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((item, index) => (
              <AccordionItem key={item.q} value={`guarantee-faq-${index}`}>
                <AccordionTrigger className="text-left text-[0.98rem] font-medium">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
